import { render, staticRenderFns } from "./MASaldenAntrag.vue?vue&type=template&id=5892a9d6&scoped=true"
import script from "./MASaldenAntrag.vue?vue&type=script&lang=ts"
export * from "./MASaldenAntrag.vue?vue&type=script&lang=ts"
import style0 from "./MASaldenAntrag.vue?vue&type=style&index=0&id=5892a9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892a9d6",
  null
  
)

export default component.exports